import { StatsApiClient } from "../../clients/stats-client";
import { Match, MatchHistory, MatchSearchFilters, ShortMatchModel } from "./models/matches";

export class MatchesRepository {
    private _client: StatsApiClient;

    constructor() {
        this._client = new StatsApiClient('/api/v2/matches');
    }

    async getHistory(playerId: number, page: number, valuesOnPageCount: number): Promise<ApiPaginationResponse<MatchHistory>> {
        return await this._client.getWithPagination<MatchHistory>("history", page, { playerId: playerId.toString() }, valuesOnPageCount);
    }

    async search(filters: MatchSearchFilters, page: number, valuesOnPageCount: number): Promise<ApiPaginationResponse<ShortMatchModel>> {
        return await this._client.getWithPagination<ShortMatchModel>("search", page, {
            heroName: filters.hero,
            talentName: filters.talent
        }, valuesOnPageCount);
    }

    async get(dotaMatchId: number): Promise<ApiDataResponse<Match>> {
        return await this._client.get<Match>("", { dotaMatchId: dotaMatchId.toString() });
    }

    async getShort(dotaMatchId: number): Promise<ApiDataResponse<ShortMatchModel>> {
        return await this._client.get<ShortMatchModel>("short", { dotaMatchId: dotaMatchId.toString() });
    }
}
